// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {

	// === 1. LÓGICA DEL TICKET DE COMPRA Y LOCALSTORAGE ===
	const ticketContainer = document.getElementById('ticket-items-container');
	const totalElement = document.getElementById('ticket-total-price');
	const sheetContainer = document.getElementById('sheet-items-container');
	const sheetTotalElement = document.getElementById('sheet-total-price');
	const cartBadgeElement = document.getElementById('mobile-cart-badge');

	// Inicializar Bottom Sheet para Móvil
	const sheetElement = document.getElementById('mobileCartSheet');
	let mobileSheetInstance = null;
	if (sheetElement && typeof BootstrapSheet !== 'undefined') {
		mobileSheetInstance = new BootstrapSheet(sheetElement, {
			backdrop: true,
			keyboard: true,
			focus: true,
			gestures: true
		});
	}

	if (ticketContainer && totalElement) {
		let cart = {};
		try {
			const storedCart = localStorage.getItem('maru_cart');
			if (storedCart) {
				cart = JSON.parse(storedCart);
			}
		} catch (e) {
			console.error("Error al cargar el carrito de localStorage:", e);
		}

		function renderTicket() {
			try {
				localStorage.setItem('maru_cart', JSON.stringify(cart));
			} catch (e) {
				console.error("Error al guardar el carrito en localStorage:", e);
			}

			// Limpiar contenedores
			ticketContainer.innerHTML = '';
			if (sheetContainer) sheetContainer.innerHTML = '';

			let grandTotal = 0;
			let totalQty = 0;
			let hasItems = false;

			// Crearemos dos fragmentos de documento para inyectar en paralelo
			const ticketFragment = document.createDocumentFragment();
			const sheetFragment = document.createDocumentFragment();

			for (const category in cart) {
				const items = cart[category];
				const itemKeys = Object.keys(items);
				if (itemKeys.length === 0) continue;

				hasItems = true;

				// Grupo para el ticket clásico (Desktop)
				const groupDiv = document.createElement('div');
				groupDiv.className = 'ticket-group';
				const groupTitle = document.createElement('div');
				groupTitle.className = 'ticket-group-title';
				groupTitle.textContent = category;
				groupDiv.appendChild(groupTitle);

				// Grupo clonado para el Sheet móvil
				const sheetGroupDiv = document.createElement('div');
				sheetGroupDiv.className = 'ticket-group';
				const sheetGroupTitle = document.createElement('div');
				sheetGroupTitle.className = 'ticket-group-title';
				sheetGroupTitle.textContent = category;
				sheetGroupDiv.appendChild(sheetGroupTitle);

				for (const key in items) {
					const item = items[key];
					const subtotal = item.price * item.qty;
					grandTotal += subtotal;
					totalQty += item.qty;

					const formattedSubtotal = subtotal.toFixed(2).replace('.', ',');
					const priceParts = formattedSubtotal.split(',');

					// Item para el ticket de escritorio
					const itemDiv = document.createElement('div');
					itemDiv.className = 'ticket-item d-flex gap-2 align-items-center';
					itemDiv.innerHTML = `
						<a href="#" class="text-danger  btn-delete-item" data-category="${category}" data-presentation="${key}" title="Eliminar producto">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/><path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/></svg>
						</a>
						<div class="d-flex justify-content-between w-100 align-items-center">
							<div class="d-flex align-items-center gap-2">
								<input type="number" class="qty-input ticket-qty-input" data-category="${category}" data-presentation="${key}" value="${item.qty}" min="1" aria-label="Cantidad de ${item.name}">
								<span class="fs-4">x</span>
								<span class="ticket-item-name">${item.name}</span>
							</div>
							<span class="ticket-item-price"><sup>$</sup>${priceParts[0]}<sup>,${priceParts[1]}</sup></span>
						</div>
					`;
					groupDiv.appendChild(itemDiv);

					// Item idéntico para el Bottom Sheet (móvil)
					const sheetItemDiv = document.createElement('div');
					sheetItemDiv.className = 'ticket-item d-flex gap-2 align-items-center';
					sheetItemDiv.innerHTML = `
						<a href="#" class="text-danger fs-4 btn-delete-item" data-category="${category}" data-presentation="${key}" title="Eliminar producto">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/><path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/></svg>
						</a>
						<div class="d-flex justify-content-between w-100 align-items-center">
							<div class="d-flex align-items-center gap-2">
								<input type="number" class="qty-input ticket-qty-input" data-category="${category}" data-presentation="${key}" value="${item.qty}" min="1" aria-label="Cantidad de ${item.name}">
								<span class="fs-5">x</span>
								<span class="ticket-item-name">${item.name}</span>
							</div>
							<span class="ticket-item-price"><sup>$</sup>${priceParts[0]}<sup>,${priceParts[1]}</sup></span>
						</div>
					`;
					sheetGroupDiv.appendChild(sheetItemDiv);
				}

				ticketFragment.appendChild(groupDiv);
				sheetFragment.appendChild(sheetGroupDiv);
			}

			// Inyectar en los respectivos contenedores
			if (hasItems) {
				ticketContainer.appendChild(ticketFragment);
				if (sheetContainer) sheetContainer.appendChild(sheetFragment);
			} else {
				const emptyMsg = '<p class="text-muted fs-5 mb-0">Tu lista está vacía. Añade productos para comenzar.</p>';
				ticketContainer.innerHTML = emptyMsg;
				if (sheetContainer) sheetContainer.innerHTML = emptyMsg;
			}

			// Actualizar precios totales
			const formattedTotal = grandTotal.toFixed(2).replace('.', ',');
			const totalParts = formattedTotal.split(',');
			const totalHtml = `<sup>$</sup>${totalParts[0]}<sup>,${totalParts[1]}</sup>`;

			totalElement.innerHTML = totalHtml;
			if (sheetTotalElement) sheetTotalElement.innerHTML = totalHtml;

			// Actualizar la burbuja del carrito en el header
			if (cartBadgeElement) {
				if (totalQty > 0) {
					cartBadgeElement.textContent = totalQty;
					cartBadgeElement.classList.remove('d-none');
				} else {
					cartBadgeElement.classList.add('d-none');
				}
			}
		}

		// Delegación de eventos para agregar pedido desde las tarjetas (Home)
		document.addEventListener('click', function (e) {
			const button = e.target.closest('.btn-add-order');
			if (button) {
				e.preventDefault();
				const row = button.closest('.presentacion-row');
				const card = button.closest('.product-card');

				if (!row || !card) return;

				const productName = card.querySelector('.product-title').textContent.trim();
				const categoryName = card.querySelector('.product-title').textContent.trim().toUpperCase();
				const presentation = row.querySelector('.weight').textContent.trim();
				const qtyInput = row.querySelector('.qty-input');
				const qty = parseInt(qtyInput.value) || 1;

				// Parsear precio limpiando caracteres no numéricos
				const priceText = row.querySelector('.price').textContent.replace('$', '').trim();
				const price = parseFloat(priceText) || 0;

				if (!cart[categoryName]) {
					cart[categoryName] = {};
				}

				if (cart[categoryName][presentation]) {
					cart[categoryName][presentation].qty += qty;
				} else {
					cart[categoryName][presentation] = {
						name: presentation,
						qty: qty,
						price: price
					};
				}

				qtyInput.value = 1;
				renderTicket();

				// En móvil desplegar automáticamente el Bottom Sheet del Carrito
				if (window.innerWidth < 768 && mobileSheetInstance) {
					mobileSheetInstance.show();
				}
			}
		});

		// Cambiar cantidades dentro del ticket
		document.addEventListener('change', function (e) {
			if (e.target.classList.contains('ticket-qty-input')) {
				const input = e.target;
				const category = input.getAttribute('data-category');
				const presentation = input.getAttribute('data-presentation');
				const val = parseInt(input.value) || 1;

				if (val < 1) {
					input.value = 1;
					return;
				}

				if (cart[category] && cart[category][presentation]) {
					cart[category][presentation].qty = val;
					renderTicket();
				}
			}
		});

		// Eliminar elementos del ticket
		document.addEventListener('click', function (e) {
			const deleteBtn = e.target.closest('.btn-delete-item');
			if (deleteBtn) {
				e.preventDefault();
				const category = deleteBtn.getAttribute('data-category');
				const presentation = deleteBtn.getAttribute('data-presentation');

				if (cart[category] && cart[category][presentation]) {
					delete cart[category][presentation];
					if (Object.keys(cart[category]).length === 0) {
						delete cart[category];
					}
					renderTicket();
				}
			}
		});

		// Enviar pedido por WhatsApp
		const sendWhatsappBtn = document.getElementById('btn-send-whatsapp');
		if (sendWhatsappBtn) {
			sendWhatsappBtn.addEventListener('click', function (e) {
				e.preventDefault();
				let message = "¡Hola! Quiero realizar este pedido:\n\n";
				let grandTotal = 0;
				let hasItems = false;

				for (const category in cart) {
					const items = cart[category];
					const itemKeys = Object.keys(items);
					if (itemKeys.length === 0) continue;

					hasItems = true;
					message += `*${category}*\n`;

					for (const key in items) {
						const item = items[key];
						const subtotal = item.price * item.qty;
						grandTotal += subtotal;

						const formattedPrice = subtotal.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
						message += `- ${item.qty} x ${item.name} (${formattedPrice})\n`;
					}
					message += '\n';
				}

				if (!hasItems) {
					alert('Tu ticket está vacío. Agrega productos antes de enviar.');
					return;
				}

				const formattedTotal = grandTotal.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
				message += `*Total:* ${formattedTotal}`;

				const phone = '5493513946268';
				const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
				window.open(url, '_blank');
			});
		}

		// Conectar el botón de WhatsApp del Bottom Sheet al disparador principal
		const sheetSendWhatsappBtn = document.getElementById('btn-sheet-send-whatsapp');
		if (sheetSendWhatsappBtn) {
			sheetSendWhatsappBtn.addEventListener('click', function (e) {
				e.preventDefault();
				if (sendWhatsappBtn) {
					sendWhatsappBtn.click();
				}
			});
		}

		renderTicket();
	}

	// === 2. FILTRADO DE CATEGORÍAS (Home) ===
	const menuLinks = document.querySelectorAll('#wrapper-navbar a, .menu a, .navbar-nav a');
	if (menuLinks.length > 0) {
		menuLinks.forEach(link => {
			const text = link.textContent.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
			if (['todos', 'congelados', 'horneados'].includes(text)) {
				link.addEventListener('click', function (e) {
					const isHome = document.body.classList.contains('page-template-blank-home') || document.body.classList.contains('home') || window.location.pathname === '/' || window.location.pathname === '/maru/';
					if (isHome) {
						e.preventDefault();

						menuLinks.forEach(l => {
							const parentLi = l.closest('li');
							if (parentLi) {
								parentLi.classList.remove('active', 'current-menu-item', 'current_page_item', 'current-menu-ancestor');
							}
						});

						const parentLi = link.closest('li');
						if (parentLi) {
							parentLi.classList.add('active', 'current-menu-item');
						}

						const cards = document.querySelectorAll('.product-card');
						cards.forEach(card => {
							const cardCat = card.getAttribute('data-category');
							if (text === 'todos' || cardCat === text) {
								card.classList.remove('d-none');
							} else {
								card.classList.add('d-none');
							}
						});
					} else {
						e.preventDefault();
						const homeUrl = document.querySelector('.logo a')?.getAttribute('href') || '/';
						const targetUrl = new URL(homeUrl, window.location.origin);
						targetUrl.searchParams.set('filter', text);
						window.location.href = targetUrl.toString();
					}
				});
			}
		});

		const isHome = document.body.classList.contains('page-template-blank-home') || document.body.classList.contains('home') || window.location.pathname === '/' || window.location.pathname === '/maru/';

		if (isHome) {
			const urlParams = new URLSearchParams(window.location.search);
			const filterParam = urlParams.get('filter');

			if (filterParam && ['todos', 'congelados', 'horneados'].includes(filterParam)) {
				menuLinks.forEach(l => {
					const parentLi = l.closest('li');
					if (parentLi) {
						parentLi.classList.remove('active', 'current-menu-item', 'current_page_item', 'current-menu-ancestor');
					}
				});

				menuLinks.forEach(link => {
					const text = link.textContent.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
					if (text === filterParam) {
						const parentLi = link.closest('li');
						if (parentLi) {
							parentLi.classList.add('active', 'current-menu-item');
						}
					}
				});

				const cards = document.querySelectorAll('.product-card');
				cards.forEach(card => {
					const cardCat = card.getAttribute('data-category');
					if (filterParam === 'todos' || cardCat === filterParam) {
						card.classList.remove('d-none');
					} else {
						card.classList.add('d-none');
					}
				});
			} else {
				menuLinks.forEach(link => {
					const text = link.textContent.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
					if (text === 'todos') {
						const parentLi = link.closest('li');
						if (parentLi) {
							parentLi.classList.add('active', 'current-menu-item');
						}
					}
				});
			}
		}
	}

	// === 3. SLIDER DE ICONOS INTERACTIVO (Servicios) ===
	const featureIcons = document.querySelectorAll('.slider-icons-container .btn');
	const bubbleText = document.getElementById('feature-bubble-text');

	if (featureIcons.length > 0 && bubbleText) {
		let currentIndex = 0;
		let autoPlayInterval = null;
		const intervalTime = 4000; // Rotación cada 4 segundos

		function updateArrowPosition() {
			const activeBtn = featureIcons[currentIndex];
			const bubbleElement = bubbleText.closest('.feature-bubble');
			if (activeBtn && bubbleElement) {
				const bubbleRect = bubbleElement.getBoundingClientRect();
				const activeBtnRect = activeBtn.getBoundingClientRect();
				const arrowLeft = (activeBtnRect.left + (activeBtnRect.width / 2)) - bubbleRect.left;
				bubbleElement.style.setProperty('--arrow-left', `${arrowLeft}px`);
			}
		}

		function showFeature(index) {
			if (index < 0 || index >= featureIcons.length) return;
			currentIndex = index;

			featureIcons.forEach((btn, idx) => {
				if (idx === index) {
					btn.classList.add('active');
				} else {
					btn.classList.remove('active');
				}
			});

			updateArrowPosition();

			const activeBtn = featureIcons[index];
			const message = activeBtn.getAttribute('data-message');

			bubbleText.style.opacity = '0';
			setTimeout(() => {
				bubbleText.textContent = message;
				bubbleText.style.opacity = '1';
			}, 150);
		}

		window.addEventListener('resize', updateArrowPosition);

		function startAutoPlay() {
			stopAutoPlay();
			autoPlayInterval = setInterval(() => {
				let nextIndex = (currentIndex + 1) % featureIcons.length;
				showFeature(nextIndex);
			}, intervalTime);
		}

		function stopAutoPlay() {
			if (autoPlayInterval) {
				clearInterval(autoPlayInterval);
				autoPlayInterval = null;
			}
		}

		featureIcons.forEach((btn, index) => {
			// Cambiar al hacer hover
			btn.addEventListener('mouseenter', function () {
				stopAutoPlay();
				showFeature(index);
			});

			// Reanudar autoplay al quitar el cursor del botón
			btn.addEventListener('mouseleave', function () {
				startAutoPlay();
			});

			// Mantener evento click para soporte móvil/pantalla táctil
			btn.addEventListener('click', function (e) {
				e.preventDefault();
				stopAutoPlay();
				showFeature(index);
				startAutoPlay();
			});
		});

		// Iniciar autoplay de entrada
		startAutoPlay();
	}

	// === 4. PIE DE FOTO DINÁMICO DEL CAROUSEL (Servicios) ===
	const carouselEl = document.getElementById('destacadoCarousel');
	const captionContainer = document.getElementById('carousel-caption-container');

	if (carouselEl && captionContainer) {
		carouselEl.addEventListener('slid.bs.carousel', function (e) {
			const activeItem = e.relatedTarget;
			const caption = activeItem.getAttribute('data-caption');
			if (caption) {
				captionContainer.style.opacity = '0';
				setTimeout(() => {
					captionContainer.textContent = caption;
					captionContainer.style.opacity = '1';
				}, 150);
			}
		});
	}

	// === 5. GALERÍA INTERACTIVA (Quiénes somos) ===
	const thumbs = document.querySelectorAll('.gallery-thumbs .thumb-btn');
	const flipInner = document.getElementById('gallery-flip-inner');
	const imgFront = document.getElementById('gallery-img-front');
	const imgBack = document.getElementById('gallery-img-back');

	if (thumbs.length > 0 && flipInner && imgFront && imgBack) {
		let currentThumbIndex = 0;
		let galleryInterval = null;
		const playTime = 5000; // Rotación de fotos cada 5 segundos

		function changeMainImage(index) {
			if (index < 0 || index >= thumbs.length) return;
			currentThumbIndex = index;

			thumbs.forEach((btn, idx) => {
				if (idx === index) {
					btn.classList.add('active');
				} else {
					btn.classList.remove('active');
				}
			});

			const activeThumb = thumbs[index];
			const fullUrl = activeThumb.getAttribute('data-full-url');

			if (flipInner.classList.contains('flipped')) {
				// Mostrando cara Back, actualizamos la Front y volteamos al frente
				imgFront.src = fullUrl;
				flipInner.classList.remove('flipped');
			} else {
				// Mostrando cara Front, actualizamos la Back y volteamos atrás
				imgBack.src = fullUrl;
				flipInner.classList.add('flipped');
			}
		}

		function startGalleryPlay() {
			stopGalleryPlay();
			galleryInterval = setInterval(() => {
				let nextIndex = (currentThumbIndex + 1) % thumbs.length;
				changeMainImage(nextIndex);
			}, playTime);
		}

		function stopGalleryPlay() {
			if (galleryInterval) {
				clearInterval(galleryInterval);
				galleryInterval = null;
			}
		}

		thumbs.forEach((btn, index) => {
			btn.addEventListener('mouseenter', function () {
				stopGalleryPlay();
				changeMainImage(index);
			});

			btn.addEventListener('mouseleave', function () {
				startGalleryPlay();
			});

			btn.addEventListener('click', function (e) {
				e.preventDefault();
				stopGalleryPlay();
				changeMainImage(index);
				startGalleryPlay();
			});
		});

		startGalleryPlay();
	}

	// === 6. CERRAR OFFCANVAS AL HACER CLIC EN LOS ENLACES (MÓVIL) ===
	const offcanvasElement = document.getElementById('navbarNavOffcanvas');
	if (offcanvasElement) {
		const closeBtn = offcanvasElement.querySelector('.btn-close');
		const links = offcanvasElement.querySelectorAll('.navbar-nav .menu-item a');
		links.forEach(link => {
			link.addEventListener('click', function () {
				if (closeBtn) {
					closeBtn.click();
				}
			});
		});
	}

	// === 7. LEER MÁS EN DESCRIPCIONES DE PRODUCTOS ===
	const descriptions = document.querySelectorAll('.product-description');
	descriptions.forEach(desc => {
		const button = desc.parentNode.querySelector('.btn-read-more');
		if (button) {
			// Comprobamos si el texto excede el espacio de 5 líneas
			if (desc.scrollHeight > desc.clientHeight) {
				button.classList.add('is-visible');
				
				// Seteamos la altura inicial para la transición
				desc.style.maxHeight = '125px';

				button.addEventListener('click', function (e) {
					e.preventDefault();
					if (desc.classList.contains('is-expanded')) {
						// Para contraer suavemente:
						// 1. Reducimos la altura máxima al valor base.
						desc.style.maxHeight = '125px';
						
						// 2. Esperamos a que la transición de altura termine antes de aplicar el line-clamp (para que no corte el texto bruscamente).
						const handleTransitionEnd = function(event) {
							if (event.propertyName === 'max-height') {
								desc.classList.remove('is-expanded');
								desc.removeEventListener('transitionend', handleTransitionEnd);
							}
						};
						desc.addEventListener('transitionend', handleTransitionEnd);
						
						button.textContent = 'Leer más';
					} else {
						// Para expandir suavemente:
						// 1. Quitamos el line-clamp agregando la clase is-expanded de inmediato.
						desc.classList.add('is-expanded');
						// 2. Cambiamos la altura máxima al scrollHeight real para iniciar la transición.
						desc.style.maxHeight = desc.scrollHeight + 'px';
						button.textContent = 'Leer menos';
					}
				});
			}
		}
	});
});